import { useShallow } from 'zustand/shallow'

import useDialogsStore from '@/stores/DialogsStore'

import EyeIcon from './icons/EyeIcon'

type Props = {
  hubId: string
}

function ShowPreviewButton({ hubId }: Props) {
  const toggle = useDialogsStore(useShallow(state => state.toggle))
  const setConfigPreviewInfo = useDialogsStore(store => store.setConfigPreviewInfo)

  const handleClick = () => {
    setConfigPreviewInfo(hubId)
    toggle('configurationPreview')
  }

  return (
    <button
      type="button"
      className="
        mt-auto flex w-full items-center justify-center rounded-b
        bg-rsf-purple-light py-3 hover:bg-rsf-purple-hover"
      onClick={handleClick}
    >
      <EyeIcon className="h-[14px] w-[22px]" />
    </button>
  )
}

export { ShowPreviewButton }
